import styled from "styled-components";

export const DashboardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #f5f5f5;
  overflow-y: auto;
  .logo_box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
  }
  .logo_box img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
export const DasboardTopBar = styled.div`
  display: flex;
  align-items: center;
  .bar_title {
    display: flex;
    flex-grow: 1;
  }
`;
